import React from "react";
import "./GeneralTemplate.css";

const Section1_Data = ({
  imageSrc,
  imageAlt,
  title,
  description,
  buttonLabel,
  onButtonClick,
}) => {
  return (
    <section className="TitleProps_section1">
      {/* This hero image carries the page's subject, so it needs real alt text.
          It was previously alt=" " — a single space, which reads as neither
          descriptive nor decorative. Callers can override via imageAlt. */}
      <img
        src={imageSrc}
        alt={imageAlt || `${title} services at Happy Technovation`}
        className="TitleProps_section1-image"
        fetchpriority="high"
      />
      <div className="TitleProps_section1-content">
        <h1>{title}</h1>
        <p>{description}</p>
        <button onClick={onButtonClick}>{buttonLabel}</button>
      </div>
    </section>
  );
};
export default Section1_Data;
